import { render, staticRenderFns } from "./public-commercial-protocol.vue?vue&type=template&id=4916825a&"
import script from "./public-commercial-protocol.vue?vue&type=script&lang=js&"
export * from "./public-commercial-protocol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4916825a')) {
      api.createRecord('4916825a', component.options)
    } else {
      api.reload('4916825a', component.options)
    }
    module.hot.accept("./public-commercial-protocol.vue?vue&type=template&id=4916825a&", function () {
      api.rerender('4916825a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/commercial/partials/public-commercial-protocol.vue"
export default component.exports